import { render, staticRenderFns } from "./WaitingCredentialsCard.vue?vue&type=template&id=778b658f&scoped=true&"
import script from "./WaitingCredentialsCard.vue?vue&type=script&lang=js&"
export * from "./WaitingCredentialsCard.vue?vue&type=script&lang=js&"
import style0 from "./WaitingCredentialsCard.vue?vue&type=style&index=0&id=778b658f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "778b658f",
  null
  
)

export default component.exports